export default {
  titles: {
    dashboard: 'Dashboard',
    reviews: 'Program Reviews',
    customers: 'Your Customers',
    loyalty: 'Loyalty',
    loyalty_status: 'Loyalty Status',
    loyalty_results: 'Loyalty Results',
    feedback: 'Feedback',
    feedback_overview: 'Overview',
    comparative: 'Comparative Insights',
    insights: 'Insights',
    insights_overview: 'Overview',
    customer_lifecycle: 'Customer Lifecycle',
    top_members: 'Top Members',
    quartile: 'Quartile',
    frequency: 'Frequency',
    subscription: 'Email Subscription',
    promote: 'Promote',
    company: 'Company',
    access: 'Setup',
    access_overview: 'Overview',
    campaigns: 'Campaigns',
    results: 'Results',
    signups: 'Signups',
    campaign_results: 'Campaign Results',
    feedback_results: 'Feedback (score card)',
    campaign_rewards: 'Rewards',
    rewards: 'Offers',
    reward_templates: 'Offer templates',
    points: 'Points',
    cms: 'Brand & Content',
    dashboard_access: 'Dashboard access',
    ordering_conversion: 'Ordering conversion',
    average_check: 'Average check',
    engagement: 'Engagement',
    tiers: 'Tiers',
    help: 'Help',
    new: 'NEW',
  },
  coming_soon: 'Coming soon',
  new: 'New',
  beta: 'Beta',
  home: 'Home',
  profile_menu: {
    access: 'Dashboard access',
    billing: 'Billing',
    edit_profile: 'Edit profile',
    integrations: 'Integrations',
    locations: 'Locations',
    log_out: 'Log out',
    merchant_selector: {
      title: 'Switch merchant',
    },
    settings: 'Settings',
    thanx_admin: 'Thanx admin: switch user',
    integrations_admin_only: 'Requires Admin role',
    user_support: 'End-user support',
    live_updates_dev_tools: 'Live Updates dev tools',
  },
  legacy: {
    reports: 'Legacy reports',
    features: 'Legacy features',
    label: 'Legacy',
    learn_more: 'Learn more',
  },
  campaigns_menu: {
    button: 'Campaigns',
    overview: 'Overview',
    targeted: 'Targeted campaigns',
    automated: 'Automated campaigns',
    message: 'Message to everyone',
    reporting: 'Reporting',
    performance: 'Campaign performance',
    all_campaigns: 'All campaigns',
  },
  loyalty_menu: {
    button: 'Loyalty',
    points: 'Points',
    points_not_configured: 'Points program is not configured',
    points_archived: 'Points program is archived',
    tiers: 'Tiers',
    loyalty_setup: 'Loyalty setup',
    exclusive_deals: 'Exclusive deals',
  },
  rewards_menu: {
    button: 'Offers',
    rewards: 'Offer templates',
    rewards_accounting: 'Rewards accounting',
    reward_activity: 'Reward activity',
    games: 'Games',
    promo_codes: 'Universal promo codes',
  },
  customers_menu: {
    button: 'Customers',
    sections: {
      manage_customers: {
        title: 'Manage customers',
        all_customers: 'All customers',
        user_lists: 'Customer lists',
        segments: 'Segments',
        ai_segment_builder: 'SegmentAI',
      },
      activity: {
        title: 'Activity',
        daily_activity: 'Daily activity',
        purchases: 'Purchases',
        revenue: 'Revenue',
        signups: 'Signups',
        suppressions: 'Suppressions',
      },
      customer_lifecycle: {
        title: 'Customer Lifecycle',
        activation: 'Activation',
        engagement: 'Engagement',
        retention: 'Retention',
        overview: 'Overview',
      },
      insights: {
        title: 'Insights',
        lifecycle: 'Customer lifecycle',
        capture_rate: 'Revenue capture rate',
        average_check: 'Average check',
        frequency: 'Frequency',
        sherlock_ai: 'SherlockAI',
        sherlock_ai_open_error: 'Could not open SherlockAI. Please try again.',
      },
      insights_lab: {
        navbar_link: 'Thanx Insights Lab',
      },
      insights_lab_v2: {
        recommended_reports: 'Recommended Reports',
        favorites: 'Favorite Reports',
        // Shared "+N more" overflow copy for both the Recommended reports and
        // Favorites nav columns.
        more_reports: '+%{count} more',
        explore_all_reports: 'Explore all reports',
        explore_all_reports_subtitle: 'Browse your full catalog of reports',
        revenue: {
          title: 'Revenue',
          capture_rate: 'Revenue capture rate',
          location_revenue: 'Revenue',
        },
      },
      legacy: {
        top_members: 'Top members',
        quartile: 'Quartile',
        frequency: 'Frequency',
        import_email_subscribers: 'Import email subscribers',
      },
    },
  },
  feedback_menu: {
    button: 'Feedback',
    overview: 'Overview',
    nps: 'NPS',
    respond: 'Respond to customer feedback',
    sentiment: 'Sentiment analysis',
    return_rate: 'Return rate',
    report_card: 'Report card',
  },
  experiences_menu: {
    button: 'Digital experiences',
    b_and_c: 'Brand & content',
    live_updates: 'Live updates',
    app_downloads: 'App downloads',
    digital_ordering: 'Digital ordering',
    ordering_management: 'Ordering management',
    ordering_error_messages: 'Ordering error messages',
    ordering_conversion: 'Ordering conversion',
    smart_links: 'Smart links',
    stored_value: 'Stored Value',
    gift_cards: 'Gift cards',
    ordering_suffix: '+ ordering enabled',
    ordering_management_suffix: '+ ordering management',
    live_updates_ordering_required: 'Requires "ordering" to be enabled',
  },
  settings_menu: {
    button: 'Settings',
    sections: {
      ordering: 'Ordering',
      loyalty_and_in_store: 'Loyalty & In-Store',
      other: 'Other',
    },
    ordering_configuration: 'Ordering configuration',
    unavailable_item_visibility: '86ed items',
    time_based_menu_visibility: 'Time-based menu items',
    delivery_default_logic: 'Delivery default',
    preferences_modal_setting: 'Location selection',
    ordering_error_messages: 'Ordering error messages',
    checkout_message: 'Custom checkout message',
    promo_code_visibility: 'Promo code visibility',
    reward_settings: 'Reward Settings',
    receipt_settings: 'Receipt settings',
    scannable_codes: 'Scannable codes',
    email_reply_routing: 'Email reply addresses',
    post_order_feedback: 'Post order receipt emails',
    instore_enrollment: 'In-store enrollment',
    instore_purchase_tracking: 'In-store purchase tracking',
    terms_and_policies: 'Terms and policies',
    smart_links: 'Smart links',
    analytics: 'Facebook & Google Analytics',
  },
  games_menu: {
    button: 'Games',
  },
  recovery_ai_menu: {
    button: 'RecoveryAI',
    configuration: 'Configuration',
  },
  operations_center_menu: {
    button: 'Operations',
    thanx_ai: 'ThanxAI',
    recovery_ai: 'RecoveryAI',
    digital_ordering: 'Digital ordering',
    support: 'Support',
    ordering_error_report: 'Ordering error report',
    // "Order feedback"/"Order ratings", not "Order TU/TD": TU/TD is internal
    // shorthand and this would have been its only user-facing use. Order
    // feedback is the settings/inbox page; Order ratings is the renamed 👍/👎
    // Looker report — they used to be one combined nav entry (AI-1257 split
    // them into separate pages, AI-1337 splits the nav entry to match).
    order_feedback: 'Order feedback',
    order_ratings: 'Order ratings',
    nps_feedback: 'NPS feedback',
    alert_banner: 'Alert banner',
    alert_banner_settings: 'Alert banner settings',
    end_user_support: 'End user support',
    locations: 'Locations',
    pos_configurations: 'POS configurations',
    delivery_location_settings: 'Delivery & location settings',
    revenue_centers: 'Revenue Centers',
    ordering_suffix: '+ ordering enabled',
  },
  permission_tooltip: {
    requires_permission: 'Requires "%{label}" permission',
    requires_one_of: 'Requires one of %{labels} permissions',
    // Suffix for write-gated controls, where view-only access isn't enough.
    view_and_edit_suffix: '(view and edit)',
  },
}
